export const PAGE_WIDTH_INCHES = 8.5;
export const PAGE_HEIGHT_INCHES = 11;
export const POINTS_PER_INCH = 72;
export const PAGE_WIDTH_PT = PAGE_WIDTH_INCHES * POINTS_PER_INCH;
export const PAGE_HEIGHT_PT = PAGE_HEIGHT_INCHES * POINTS_PER_INCH;
export const VOUCHER_GUIDES_INCHES = [3.5, 7];
export const THREE_PER_PAGE_BAND_INCHES = 3.5;
export const THREE_PER_PAGE_SLOTS = 3;

export const pageLayoutBandHeight = (pageLayout) =>
  pageLayout === "threePerPage" ? THREE_PER_PAGE_BAND_INCHES : PAGE_HEIGHT_INCHES;

export const inchesToPoints = (inches) => Number(inches || 0) * POINTS_PER_INCH;

export const pointsToInches = (points) => Number(points || 0) / POINTS_PER_INCH;

export const inchesToPixels = (inches, pixelsPerInch) =>
  Number(inches || 0) * Number(pixelsPerInch);

export const pixelsToInches = (pixels, pixelsPerInch) =>
  Number(pixelsPerInch) ? Number(pixels || 0) / Number(pixelsPerInch) : 0;

export const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

export const roundInches = (value, places = 3) => {
  const factor = 10 ** places;
  return Math.round(Number(value || 0) * factor) / factor;
};

export const snapInches = (value, step = 0.05) => {
  const size = Number(step) || 0.05;
  return roundInches(Math.round(Number(value || 0) / size) * size);
};

export const VOUCHER_BANDS = [
  { id: "check", label: "Check", topInches: 0, heightInches: 3.5 },
  { id: "payeeCopy", label: "Payee copy", topInches: 3.5, heightInches: 3.5 },
  { id: "officeCopy", label: "Organization copy", topInches: 7, heightInches: 4 },
];

export const bandForYInches = (yInches, pageLayout) => {
  if (pageLayout === "threePerPage") {
    return { id: "check", label: "Check", topInches: 0, heightInches: 3.5 };
  }
  const y = Number(yInches) || 0;
  return (
    [...VOUCHER_BANDS].reverse().find((band) => y >= band.topInches) ||
    VOUCHER_BANDS[0]
  );
};

export const fieldSlotYInches = (yInches, slotIndex, bandHeightInches) =>
  Number(yInches || 0) + Number(slotIndex || 0) * Number(bandHeightInches || 0);

/**
 * Convert a top-left field box in inches to pdf-lib draw coordinates (bottom-left origin).
 * baselineAdjust matches generate-pdf: top of the box minus font size.
 */
export const fieldToPdf = ({
  xInches,
  yInches,
  widthInches,
  heightInches,
  fontSizePt,
  offsetXInches = 0,
  offsetYInches = 0,
  slotIndex = 0,
  bandHeightInches = PAGE_HEIGHT_INCHES,
  pageHeightPt = PAGE_HEIGHT_PT,
}) => {
  const x = inchesToPoints(Number(xInches) + Number(offsetXInches));
  const topYInches =
    fieldSlotYInches(yInches, slotIndex, bandHeightInches) + Number(offsetYInches);
  const width = inchesToPoints(widthInches);
  const height = inchesToPoints(heightInches);
  const size = Number(fontSizePt) || 12;
  const pdfY = pageHeightPt - inchesToPoints(topYInches) - size;
  return {
    x,
    y: pdfY,
    width,
    height,
    size,
    topPdfY: pageHeightPt - inchesToPoints(topYInches),
  };
};

export const clampFieldToBand = (field, bandHeightInches = PAGE_HEIGHT_INCHES) => {
  const width = clamp(Number(field.widthInches) || 0.5, 0.25, PAGE_WIDTH_INCHES);
  const height = clamp(Number(field.heightInches) || 0.2, 0.15, bandHeightInches);
  const xInches = clamp(Number(field.xInches) || 0, 0, PAGE_WIDTH_INCHES - width);
  const yInches = clamp(Number(field.yInches) || 0, 0, bandHeightInches - height);
  return {
    ...field,
    xInches: roundInches(xInches),
    yInches: roundInches(yInches),
    widthInches: roundInches(width),
    heightInches: roundInches(height),
  };
};
